const ConfirmBrowserRefresh = {
  mounted() {
    window.addEventListener('beforeunload', this.handleBrowserRefresh)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handleBrowserRefresh)
  },
  handleBrowserRefresh(event) {
    event.preventDefault()
  },
}

export default ConfirmBrowserRefresh
